import React from 'react'

import { IntegrationServiceId } from '../../../common/integrations'
import { useZocksQuota } from '../../../components/ScopedBlock/hooks'
import { DELTA_TRIAL_FEATURES } from '../../Plan/DeltaTrial/DeltaTrialFeatures'
import { ACCOUNT_OPENING_QUOTA } from '../../AccountOpeningWizard/hooks/useAccountOpeningQuota'
import { IntegrationUpgradeBanner, type IntegrationUpgradeBannerProps } from './IntegrationUpgradeBanner'

const INTEGRATION_UPSELLS: Partial<Record<IntegrationServiceId, { quota: string; banner: IntegrationUpgradeBannerProps }>> = {
  [IntegrationServiceId.BOX]: {
    quota: 'ai.documentSummaryAgent.value',
    banner: {
      title: 'Upload documents from Box to get instant insights',
      description:
        'Select documents directly from Box. Your AI Assistant extracts key client updates — financial changes, life events, and more. Review the insights and sync them to your CRM in one click.',
      deltaTrialFeatureId: DELTA_TRIAL_FEATURES['processDocument'].id,
      hideCookieName: 'hideBoxDocIntelUpsell',
    },
  },
  [IntegrationServiceId.SCHWAB]: {
    quota: ACCOUNT_OPENING_QUOTA,
    banner: {
      title: 'Open Schwab accounts directly from Zocks',
      description:
        'Your AI Assistant fills out Schwab applications using details from meetings, emails and connected systems. It checks every field against Schwab’s requirements before you submit, so fewer applications come back NIGO.',
      deltaTrialFeatureId: DELTA_TRIAL_FEATURES['accountOpening'].id,
      hideCookieName: 'hideSchwabAccountOpeningUpsell',
    },
  },
}

interface IntegrationUpsellBannerProps {
  serviceId: IntegrationServiceId
}

export const IntegrationUpsellBanner: React.FC<IntegrationUpsellBannerProps> = ({ serviceId }) => {
  const { hasQuota, quotaSuccess } = useZocksQuota()
  const upsell = INTEGRATION_UPSELLS[serviceId]
  if (!upsell || !quotaSuccess) {
    return null
  }
  const hasUpsellQuota = hasQuota(upsell.quota)
  if (hasUpsellQuota) {
    return null
  }

  return (
    <div className='w-75 mw-800 mt-4'>
      <IntegrationUpgradeBanner {...upsell.banner} />
    </div>
  )
}
